<template>
	<div ref="boxRef">
		<el-dialog
			v-model="visible"
			@close="dialogClose"
			class="showLoginDialog"
			header-class="headerClass"
			body-class="bodyClass"
			:show-close="false"
			append-to-body
			width="588px"
			:top="getDialogTop()"
			>
			<div class="content flex-column flex-center">
				<img class="showLoginBanner" :src="ImageParameterSplicing(showLoginBanner||'',500)" >
				<div class="title">{{title}}</div>
				<div class="toLogin" @click="toLogin">
					<img class="imgBtn" src="@/assets/images/toLogin.png" alt="">
					<!-- <el-image class="imgBtn" src="@/assets/images/toLogin.png">
						<template #error>
							<div class="image-slot">
								<el-button size="large" class="">立即登录</el-button>
							</div>
						</template>
					</el-image> -->
				</div>
				<div class="close" @click.prevent="close">
					<el-icon><CircleClose /></el-icon>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script setup>
	import {ref,getCurrentInstance,onMounted,watch,computed} from "vue";
	let {proxy} = getCurrentInstance();
	import { useStore } from "@/store";
	let store = useStore();
	let userInfo = computed(()=>store.state.user);
	import _showLoginBanner from '@/assets/images/showLoginBanner.png';
	let showLoginBanner = ref(_showLoginBanner);
	let title = ref('边看边聊，高清直播');
	let visible = ref(false);
	let boxRef = ref();
	let getDialogTop = ()=>{
		if(proxy.isMobileDevice() || proxy.isIpad()){
			return '5vh';
		}else{
			return '15vh';
		}
	}
	let dialogClose = ()=>{
		if(xgPlayerStatus=='playing'){//还在播放中需重新启动定时器
			timedPopup();
		}
		addVisitRecord('AdClose',{duration:(timedPopupInterval / 1000)});
	}
	let toLogin = ()=>{
		visible.value = false;
		// proxy.$router.push('/signIn');
		proxy.$bus.emit('showLoginPopup');
		if(xgPlayerStatus=='playing'){
			closeTimePopup();
		}
		addVisitRecord('AdClient',{duration:(timedPopupInterval / 1000)});
	}
	let show = ()=>{
		visible.value = true;
	}
	let close = ()=>{
		visible.value = false;
		// let elOverlayDialog = document.querySelectorAll('.el-overlay-dialog');
		// let dom = Array.from(elOverlayDialog).find(item=>Array.from(item.children).find(c=>/showLoginDialog/.test(c.className)));
		// if(dom){
		// 	// console.log('dom',dom);
		// 	dom.click();
		// 	dom.focus();
		// }
	}
	let startUp = computed(()=>store.state.startUp);
	watch(()=>startUp.value,(v)=>{
		// console.log('watch-startUp:',v);
		let has = v.advertData.filter(e=>e.nativeType == 4 && e.endTimestamp > Date.now()).sort((a,b)=>a.startTimestamp - b.startTimestamp).find(()=>true);
		if(has){
			let imgUrl = has.advertImageUrl;
			showLoginBanner.value = imgUrl;
			title.value = has.title;
			proxy.loadImage(proxy.ImageParameterSplicing(imgUrl||'',500));//预加载图片
			// console.log('watch-startUp-showLoginBanner.value:',showLoginBanner.value);
		}
	},{deep:true})
	
	let timedPopupTime = 0;
	let timedPopupInterval = 1000*60*5;//5分钟
	let pausePlayInterval = 1000*60;//暂停播放的间隔
	let timedPopupIntervaler = null;
	let pausePlayTimeout = null;
	let timedPopup = ()=>{
		closeTimePopup();
		if(!timedPopupTime){
			timedPopupTime = Date.now();
		}
		timedPopupIntervaler = setInterval(()=>{
			if(Date.now() > timedPopupTime + timedPopupInterval){
				if(!visible.value){
					visible.value = true;
					proxy.$bus.emit('xgplayer-exitFullscreen');//使播放器退出全屏
					clearTimeout(pausePlayTimeout);
					timedPopupTime = 0;
					pausePlayTimeout = setTimeout(()=>{
						proxy.$bus.emit('pausePlay');//暂停播放
					},pausePlayInterval)
					addVisitRecord('AdShow',{duration:(timedPopupInterval / 1000)});
				}
			}
		},1000)
	}
	let closeTimePopup = ()=>{
		clearTimeout(timedPopupIntervaler);
		clearTimeout(pausePlayTimeout);
	}
	let xgPlayerStatus = null;
	let xgplayerFullScreenStatus = false;
	onMounted(()=>{
		proxy.$bus.on('xgplayer-playStatus',(status)=>{
			xgPlayerStatus = status;
			if(status == 'playing'){
				timedPopup();
			}else if(status == 'pause'){
				closeTimePopup();
			}
		})
		proxy.$bus.on('showlogin-closeTimePopup',()=>{
			closeTimePopup();
		});
		proxy.$bus.on('closeLoginPop',()=>{
			if(!userInfo.value.id){//未登录关闭了弹窗，需要重新计时
				console.log('未登录关闭了弹窗，需要重新计时');
				if(xgPlayerStatus == 'playing'){
					timedPopup();
				}
			}
		});
		proxy.$bus.on('liveRoomInfos',(e)=>{//直播间的信息
			liveRoomInfos = e;
		});
	})
	watch(()=>userInfo.value.id,async(val,oldVal)=>{
		if(oldVal && !val){//用户退出登录
			if(xgPlayerStatus=='playing'){//还在播放中需重新启动定时器
				timedPopup();
			}
		}else{
			closeTimePopup();
		}
	})
	let liveRoomInfos = {};
	
	let addVisitRecord = (actionType,params={})=>{
		let visitRecord = {
			url: window.location.href,
			// competitionId: '',
			// seasonId: '',
			liveId: liveRoomInfos.liveRoomInfo.roomID,
			programId: (liveRoomInfos.liveAuthorDetails.programId||liveRoomInfos.liveProgramInfo.id),
			actionType
		}
		if(Object.keys(params).length){
			Object.assign(visitRecord,params);
		}
		let fields = ['sportType','matchID'];
		let sportParmas = {
			sportType:null,
			matchID:null,
		}
		fields.forEach(k=>{
			if(proxy.$route.query[k]!=undefined){
				sportParmas[k] = proxy.$route.query[k];
			}else
			if(liveRoomInfos.liveRoomInfo[k]!=undefined){
				sportParmas[k] = liveRoomInfos.liveRoomInfo[k];
			}else
			if(liveRoomInfos.liveProgramInfo[k]!=undefined){
				sportParmas[k] = liveRoomInfos.liveProgramInfo[k];
			}
		})
		Object.assign(visitRecord,sportParmas);
		return new Promise((resolve,reject)=>{
			proxy.addVisitRecord(visitRecord).then(res=>{
				if(res&&res.data.code == 200){
					resolve(res.data);
				}else{
					reject();
				}
			}).catch(err=>{
				reject(err);
			});
		})
	}
	
	
	defineExpose({
		show,
		timedPopup,
	})
	
</script>
<style>
	.showLoginDialog{
		box-shadow:unset;
	}
</style>
<style lang="scss" scoped>
	.content{
		position:relative;
		.showLoginBanner{
			width:434px;
			height:401px;
			object-fit: cover;
		}
		.title{
			font-family: YouSheBiaoTiHei;
			font-weight: 400;
			font-size: 57px;
			color: #FFFFFF;
			margin: 3px 0 18px;
			white-space: nowrap;
		}
		.toLogin{
			cursor: pointer;
			.imgBtn{
				width:231px;
				height:55px;
			}
			.image-slot{
				font-size: 30px;
				color: #FFFFFF;
				.el-button{
					font-size: 25px;
					background: var(--qx2-primary-linearGradient-color);
					border-radius: 20px;
					color: #FFFFFF;
				}
			}
		}
		.close{
			margin-top:29px;
			font-size: 40px;
			color: #fff;
			font-weight: bold;
			cursor: pointer;
			user-select:none;
			outline: none;
		}
	}
	
</style>